/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Status_Saving_ProjectInputs */



/**
* | output |
* | --- |
* | "Saving Project" |
*
* @param {Iconik_Publish_Status_Saving_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_status_saving_project = /** @type {((inputs?: Iconik_Publish_Status_Saving_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Status_Saving_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sparprojekt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект спасения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyecto de ahorro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("储蓄项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存プロジェクト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बचत परियोजना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto de economia")
	return /** @type {LocalizedString} */ ("Saving Project")
});